const taskTemplates = require('../../task-templates');

const tasksData = [		
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		taskId: 'safety-order-accident',
		title: 'Opgave 1',
		text: `Ved en alvorlig personulykke – hvad er den korrekte rækkefølge for handlingerne nedenfor? Sæt dem i rækkefølge med den første handling øverst.`,
		popupText: `På HTX lærer man grundlæggende sikkerhed og korrekt handling i kritiske situationer.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'stop', 
				text: `Start med at stoppe ulykken, så ingen kommer mere til skade`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'safety', 
				text: `Sikre tilskadekomne`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'ambulance', 
				text: `Rekvirer ambulance`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'announce-employees', 
				text: `Udsend melding om ulykke til ansatte`,
				correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'announce-supervisors', 
				text: `Anmeld ulykken til Arbejdstilsynet`,
				correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'prevent', 
				text: `Gennemgå arbejdsforhold for at undgå, at ulykken sker igen`,
				correctOrderNumbers: [6]
			}),
		]
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 1,
	// 	taskNumber: 2,
	// 	title: 'Opgave 2',
	// 	taskId: 'safety-multiple-choice-safety-poster',
	// 	text: `I skal lave en sikkerhedsplakat, der informerer om det rigtige sikkerhedsudstyr i produktionen. Vælg, hvad der skal være på plakaten.`,
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1,
	// 			text: 'Sikkerhedssko'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2,
	// 			text: 'Hårnet', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3,
	// 			text: 'Sikkerhedsbriller', 
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4,
	// 			text: 'Høreværn', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 5,
	// 			text: 'Brandslukker', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 6,
	// 			text: 'Refleksvest', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 7,
	// 			text: 'Plastikhandsker', 
	// 			isCorrect: true
	// 		}),
	// 	],
	// }),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		taskId: 'safety-sort-shelves',
		layout: 'prep-shelves',
		title: 'Opgave 2',
		text: `Sorter sikkerhedsudstyret, så det står på de rette hylder.`,
		popupText: `Sikkerhedsudstyr skal opbevares korrekt for at virke, når der er brug for det. På HTX arbejder man med sikkerhed i praksis.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'fire-stuff',
				type: 'image',
				title: `Hylde med brandudstyr`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'first-aid', 
				type: 'image',
				title: `Hylde med førstehjælp`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'safety-equipment',
				type: 'image',
				title: `Hylde med sikkerhedsudstyr`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, 
				text: `Brandslukker`,
				type: 'image',
				categoryIds: ['fire-stuff']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, 
				text: `Brandtæppe`,
				type: 'image',
				categoryIds: ['fire-stuff']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, 
				text: `Førstehjælpskasse`,
				type: 'image',
				categoryIds: ['first-aid']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, 
				text: 'Hjertestarter',
				type: 'image',
				categoryIds: ['first-aid']
			}),
			// Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
			// 	id: 5, 
			// 	text: 'Kittel',
			// 	type: 'image',
			// 	categoryIds: ['safety-equipment']
			// }),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, 
				text: 'Plastikhandsker',
				type: 'image',
				categoryIds: ['safety-equipment']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 7, 
				text: 'Sikkerhedsbriller',
				type: 'image',
				categoryIds: ['safety-equipment']
			})
		]
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 2,
	// 	taskNumber: 1,
	// 	title: 'Opgave 1',
	// 	taskId: 'extinguish-type-of-fire-pc',
	// 	subtype: 'images',
	// 	multiline: 'on',
	// 	layout: 'extinguish-pc-fire',
	// 	image: 'electrical-fire',
	// 	text: `Hvilket brandsluknings-materiel skal du helst bruge til at slukke en elektrisk brand? Tryk på de rigtige billeder.`,
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'particle', // pulverslukker
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'water', // slangevinde
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'co2', // CO2 
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'blanket', // brandtæppe
	// 		}),
	// 	],
	// }),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 3,
		title: 'Opgave 3A',
		taskId: 'extinguish-type-of-fire-liquid',
		subtype: 'images',
		multiline: 'on',
		layout: 'extinguish-liquid-fire',
		image: 'liquid-fire',
		text: `Hvilket brandsluknings-materiel bør bruges til at slukke en brand i væske? Tryk på de rigtige billeder.`,
		hintText: `Tænk på hvad der <b>ikke må bruges på væske</b>, fordi det kan sprede branden.`,
		popupText: `Brande i væsker kræver særligt slukningsudstyr. På HTX lærer man at vælge korrekt brandslukning for at arbejde sikkert med kemi og teknik.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'particle', // pulverslukker
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'water', // slangevinde
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'co2', // CO2 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'blanket', // brandtæppe
			}),
		],
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 2,
	// 	taskNumber: 3,
	// 	title: 'Opgave 3',
	// 	taskId: 'extinguish-type-of-fire-furniture',
	// 	lockedById: 'extinguish-type-of-fire-liquid',
	// 	subtype: 'images',
	// 	multiline: 'on',
	// 	layout: 'extinguish-furniture-fire',
	// 	image: 'furniture-fire',
	// 	text: `Hvilket brandsluknings-materiel bør du IKKE bruge til at slukke en møbelbrand? Tryk på de rigtige billeder.`,
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'particle', // pulverslukker
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'water', // slangevinde
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'co2', // CO2 
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'blanket', // brandtæppe
	// 		}),
	// 	],
	// }),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 4,
		title: 'Opgave 3B',
		taskId: 'why-use-particle',
		lockedById: 'extinguish-type-of-fire-liquid',
		// image: 'particle-extinguisher',
		image: 'htx-safety-fire-1',
		text: `Hvorfor er det bedst at bruge pulverslukker til brand i væske, men ikke til brand i elektriske appararter?`,
		hintText: `Pulver er effektivt mod væskebrande, fordi det kvæler ilden.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, isCorrect: true,
				text: 'Pulver er svært at fjerne og kan gøre elektriske apparater ubrugelige'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, isCorrect: true,
				text: 'Pulveret kan trænge ind i elektronikken og forårsage kortslutninger og permanent skade', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, isCorrect: true,
				text: 'Pulveret danner et isolerende lag, der kvæler ilden', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'En kemisk reaktion får elektronikken til at eksplodere', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: 'Det gør ingen forskel', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6,
				text: 'Pulver er syreholdigt og kan ætse elektronikken', 
			}),
		],
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 2,
	// 	taskNumber: 5,
	// 	title: 'Opgave 5',
	// 	taskId: 'why-use-co2',
	// 	lockedById: 'why-use-particle',
	// 	image: 'co2-extinguisher',
	// 	text: `Hvorfor er CO2-slukkere effektive til elektriske brande og væskebrande, men ikke egnede til møbelbrande?`,
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1, isCorrect: true,
	// 			text: 'Fordi gassen kvæler ilden, uden at man efterfølgende har et stort oprydningsarbejde'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2, isCorrect: true,
	// 			text: 'Den kvæler ilden men køler ikke området, hvilket kan resultere i genantendelse', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3,
	// 			text: 'Det kan gøre problemet værre', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4,
	// 			text: 'Fordi den gør væsken solid', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 5,
	// 			text: 'Fordi det grisser', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 6,
	// 			text: 'Der kan opstå en kemisk reaktion med tekstilerne', 
	// 		}),
	// 	],
	// }),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 2,
	// 	taskNumber: 6,
	// 	title: 'Opgave 6',
	// 	taskId: 'why-use-water',
	// 	lockedById: 'why-use-co2',
	// 	image: 'waterhose',
	// 	text: `Hvorfor må man IKKE bruge en slangevinde til at bekæmpe brand i væske og elektronik?`,
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1, isCorrect: true,
	// 			text: 'Det kan eskalere problemet'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2, isCorrect: true,
	// 			text: 'Man risikerer at få stød', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3, isCorrect: true,
	// 			text: 'Man kan risikere at få sprøjtet den brændende væske på sig selv', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4, isCorrect: true,
	// 			text: 'Der er stor risiko for at apparartet eksplodere', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 5, isCorrect: true,
	// 			text: 'Du risikerer at branden spreder sig yderligere', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 6,
	// 			text: 'Det kan man også godt, ved at fortynde væsken til det ikke længere kan brande', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 7,
	// 			text: 'Der kan opstå en nedsmeltning af apparaturet', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 8,
	// 			text: 'Det kan forurene vandet i slangen', 
	// 		}),
	// 	],
	// }),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 5,
		title: 'Opgave 3C',
		taskId: 'why-use-a-blanket',
		lockedById: 'why-use-particle',
		image: 'htx-safety-fire-2',
		text: `Vælg de 3 situationer, hvor brandtæppet fungerer bedst?`,
		hintText: `Tænk på små brande, som du kan dække med et tæppe uden at bruge vand eller slukker.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, isCorrect: true,
				text: 'Brand i mennesker eller dyr'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, isCorrect: true,
				text: 'Til mindre brande der kan dækkes fuldt med tæppet', 
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 3, isCorrect: true,
			// 	text: 'Til at forhindre ilden i at sprede sig', 
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, isCorrect: true,
				text: 'Brændende olie i pande eller gryde', 
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 5, 
			// 	text: 'Skovbrande', 
			// }),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 6,
			// 	text: 'Brændende bygninger', 
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 7,
				text: 'Elektriske brande', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 8,
				text: 'I alle situationer', 
			}),
		],
	}),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 6,
		title: 'Opgave 4',
		taskId: 'safety-spot-errors-safety-issues',
		layout: 'prep-safety-issues',
		text: `Hvilke sikkerhedsproblemer kan I spotte her? Tryk på problemerne. Tryk OK, når I tror, I har dem alle.`,		
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'firealarm-no-battery'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'no-fire-extinguisher'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'hidden-fire-hose'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'blocking-box'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'escape-lamp-not-functional'}),
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 7,
		taskId: 'safety-order-spotted-fire',
		title: 'Opgave 5',
		text: `Hvis man spotter en brand i virksomheden, hvad skal man så gøre? Sæt handlingerne i den rigtige rækkefølge. Klik OK, når I mener, I har den.`,
		hintText: `Tænk på at først advare andre, derefter handle selv, så tilkalde hjælp og til sidst forlade stedet.`,
		popupText: `På HTX lærer man at planlægge sikkerhedsprocedurer i praksis.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'stop', 
				text: `Udløs brandalarmen`,
				correctOrderNumbers: [1]
			}),			
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'extinguish', 
				text: `Forsøg at slukke ilden hvis det er sikkert`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'call-112', 
				text: `Ring 1-1-2`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'leave-building', 
				text: `Forlad bygningen`,
				correctOrderNumbers: [4]
			}),
		]
	}),

	// CASE 2 
	
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		title: 'Opgave 1A',
		image: 'htx-safety-health-1',
		taskId: 'research-multiple-choice-vitamin-d',
		text: `Hvad hjælper Vitamin D med?`,
		hintText: `Vitamin D hjælper kroppen med at optage et vigtigt mineral til knoglerne.`,
		popupText: `Vitamin D fremmer optagelsen af calcium, hvilket styrker knoglerne. På HTX lærer man, hvordan biologisk viden anvendes i praksis.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Hjælper med at nedbryde knogler', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Er kun vigtigt for huden',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Fremmer optagelsen af calcium i knoglerne',
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Forårsager mangel på calcium i kroppen',
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		image: 'htx-safety-health-2',
		title: 'Opgave 1B',
		lockedById: 'research-multiple-choice-vitamin-d',
		taskId: 'research-multiple-choice-water-oil-solvable',
		text: `Hvilke to ting tror I, passer om vandopløselige og fedtopløselige vitaminer?`,
		options: [
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 1,
			// 	text: 'Den ene kan ikke udskilles gennem urinen',
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Vandopløselige vitaminer udskilles i urinen', 
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Alle vitaminer lagres i kroppen på samme måde',
			}),
			// Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
			// 	id: 5,
			// 	text: 'Findes kun i grøntsager',
			// }),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6,
				text: 'Vandopløselige vitaminer er farligere end fedtopløselige',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 7,
				text: 'Fedtopløselige vitaminer kan lagres i kroppen',
				isCorrect: true,
			}),

		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		image: 'htx-safety-health-3',
		title: 'Opgave 2',
		taskId: 'research-multiple-choice-difference-illness',
		text: `Hvad er forskellen mellem en sygdom og en lidelse?`,
		hintText: `Tænk på, hvilken tilstand der kan måles eller diagnosticeres, og hvilken der mere beskriver oplevelsen.`,
		popupText: `På HTX kan man lære at skelne mellem fysiske og psykiske tilstande i sundhed og forskning.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'En sygdom er en medicinsk tilstand, mens en lidelse er en naturlig del af livet', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'En sygdom har en kendt årsag, mens en lidelse ikke har det',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'En sygdom er en midlertidig tilstand, mens en lidelse er permanent',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'En sygdom handler om kroppen, mens en lidelse handler om psyken',
				isCorrect: true,
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 4,
		image: 'htx-safety-health-4',
		title: 'Opgave 3A',
		taskId: 'research-multiple-choice-muscle-growth',
		text: `Hvordan påvirker proteiner muskelvækst og restitution efter træning?`,
		hintText: `Tænk på, hvilke byggesten kroppen bruger til at reparere muskler efter hård træning.`,
		popupText: `På HTX lærer man, hvordan næringsstoffer påvirker kroppen i praksis.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Er ikke nødvendige for muskelvækst eller restitution', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Bidrager til muskelvækst og reparation af musklerne',
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Nedbryder musklerne',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Påvirker ikke muskelvækst, men kun kroppens energiniveau',
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 5,
		image: 'htx-safety-health-5',
		title: 'Opgave 3B',
		lockedById: 'research-multiple-choice-muscle-growth',
		taskId: 'research-multiple-choice-energyproduction',
		text: `Hvilken rolle spiller kulhydrater i energiproduktionen i kroppen, og hvordan kan de påvirke præstationen under fysisk aktivitet`,
		hintText: `Tænk på, hvad kroppen hurtigt kan bruge som brændstof under aktivitet.`,
		popupText: `På HTX arbejder man med, hvordan næring påvirker præstation og sundhed.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Lagres som fedt i kroppen', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Påvirker ikke præstationen under fysisk aktivitet',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Fungerer som primær energikilde under træning',
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Er kun nødvendige for mental klarhed',
			}),
		],
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 5,
	// 	taskNumber: 7,
	// 	title: 'Opgave 4A',
	// 	taskId: 'research-multiple-choice-muscle-work',
	// 	text: `Musklerne arbejder på tre forskellige måder - hvilke?`,
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1,
	// 			text: 'Excentrisk, koncentrisk og statisk', 
	// 			isCorrect: true,
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2,
	// 			text: 'Glidende, koncentreret og statistisk',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3,
	// 			text: 'Hurtigt, effektivt og glidende',
	// 		}),
	// 	],
	// }),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 6,
		image: 'htx-safety-health-6',
		title: 'Opgave 4A',
		taskId: 'research-multiple-choice-bone-amount',
		text: `Hvor mange knogler har et voksent menneske?`,
		hintText: `Google “antal knogler i voksen krop” – tænk på, at spædbørn har flere knogler, som smelter sammen med alderen.`,
		popupText: `Et voksent menneske har 206 knogler. På HTX lærer man anatomi for at forstå kroppen og sundhed i praksis.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: '101', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: '206',
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: '370',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: '488',
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 7,
		image: 'htx-safety-health-7',
		title: 'Opgave 4B',
		lockedById: 'research-multiple-choice-bone-amount',
		taskId: 'research-multiple-choice-biggest-muscle',
		text: `Hvad er kroppens største muskel?`,
		hintText: `Det er en stor muskel på bagsiden af kroppen, som hjælper med at strække hofte og bagdel.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Tungen', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Biceps',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Balderne',
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Lårmusklerne',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: 'Brystmusklerne',
			}),
		],
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 5,
	// 	taskNumber: 10,
	// 	title: 'Opgave 4D',
	// 	lockedById: 'research-multiple-choice-biggest-muscle',
	// 	taskId: 'research-multiple-choice-where-biggest',
	// 	text: `Hvor sidder kroppens største muskel?`,
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1,
	// 			text: 'Det er tungen', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2,
	// 			text: 'På armene',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3,
	// 			text: 'På røven',
	// 			isCorrect: true,
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4,
	// 			text: 'På låret',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 5,
	// 			text: 'På brystet',
	// 		}),
	// 	],
	// }),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 5,
	// 	taskNumber: 11,
	// 	title: 'Opgave 4E',
	// 	lockedById: 'research-multiple-choice-where-biggest',
	// 	taskId: 'research-multiple-choice-smallest-muscle',
	// 	text: `Hvad er kroppens mindste muskel?`,
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1,
	// 			text: 'Teres minor (muskel i ryggen)', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2,
	// 			text: 'Stapedius (muskel i mellemøret)',
	// 			isCorrect: true,
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3,
	// 			text: 'Den lille sædemuskel',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4,
	// 			text: 'Den lille brystmuskel',
	// 		}),
	// 	],
	// }),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 8,
		image: 'htx-safety-health-8',
		title: 'Opgave 4C',
		lockedById: 'research-multiple-choice-biggest-muscle',
		taskId: 'research-multiple-choice-bones-dont-swim',
		text: `Knoglerne svømmer ikke bare rundt i kroppen, de bliver holdt sammen af led. Hvilken af disse er IKKE en ledtype?`,
		hintText: `Tænk på hvilke ord, der lyder lidt sjove eller som ikke normalt bruges om ægte led i kroppen.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Drejeled', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Kugleled',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Glideled',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Rutsjeled',
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: 'Hængselled',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6,
				text: 'To-aksel-led',
			}),
		],
	}),
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'htx-prep-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};